import React from 'react';

import {
  ActionGroup,
  ActionGroupItem,
} from '@app/common/components/ActionGroup';
import { SelectableGroupField, FieldInfoGroupField } from '@app/common/configurable-wizards';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { combineNames, isSelectableGroupFiledInfo } from '@app/common/configurable-wizards/utils';

import { useDetailsSectionNavigator } from '../../hooks/useDetailsSectionNavigator';
import { AddressFieldGroups } from '../../types';
import { formatAddress } from '../../utils/labelFormatters';
import { getMappedFields } from '../../utils/subFieldsMapper';

import styles from './AddressFieldsList.pcss';

export const AddressFieldsList: FieldComponent<SelectableGroupField> = ({ parent, field, locator }) => {
  const { navigate } = useDetailsSectionNavigator();
  return (
    <ActionGroup>
      {field.fieldGroups
        .filter((item) => {
          const label = formatAddress(getMappedFields(item?.subFields || []));

          return item?.id === field.selectedFieldGroupId && label;
        })
        .map((item, index) => {
          const subField = item as FieldInfoGroupField;
          const Component = locator(subField);

          return (
            <ActionGroupItem
              data-stable-name="AddressGroupItem"
              className={styles.groupItem}
              iconClassName={styles.groupItemIcon}
              key={subField.id || index}
              onSelect={() => navigate(subField)}
            >
              <Component
                parent={combineNames(parent, field.id)}
                field={subField}
                locator={locator}
              />
            </ActionGroupItem>
          );
        })}
    </ActionGroup>
  );
};

export const AddressFieldsListLocator: FieldLocator = ({ field }) => (
  isSelectableGroupFiledInfo(field) && field.id in AddressFieldGroups
    ? AddressFieldsList
    : undefined
);
